import React, { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import CreatePlannerModal from "./Modal/CreatePlannerModal";
import ViewPlannerModal from "./Modal/ViewPlannerModal";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import AssignConfirmationModal from "./Modal/AssignConfirmationModal";

const Planner = () => {
    const userState = useSelector((state) => state.loginData.userData);
    const [plannerList, setPlannerList] = useState([]);
    const [showPlannerModal, setShowPlannerModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedPlanner, setSelectedPlanner] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showAssignConfirm, setShowAssignConfirm] = useState(false);

    useEffect(() => {
        getAllPlanner();
    }, []);

    // get all planner
    const getAllPlanner = async () => {
        const payload = {
            assignBy_id: userState?.empId
        }
        try {
            setLoading(true);
            const res = await axios.post(process.env.REACT_APP_BASE_URL + "/planner/getAllPlanner", payload);
            setPlannerList(res?.data?.data || []);
        } catch (err) {
            console.log("get planner error", err);
        } finally {
            setLoading(false);
        }
    };

    // for handler assign planner to user
    const handleAssignPlanner = async (item) => {
        try {
            const payload = {
                taskList: item?.taskList?.map((task) => ({
                    planTaskId: task?.planTaskId,
                    planeGroupId: task?.planeGroupId,
                    taskTitle: task?.taskTitle,
                    taskDescription: task?.taskDescription,
                    startDate: task?.startDate,
                    endDate: task?.endDate,
                    estimatedHours: task?.estimatedHours,
                    estimatedMinutes: task?.estimatedMinutes,
                    assignTo: task?.assignTo,
                    assignToName: task?.assignToName,
                    projectId: task?.projectId,
                    projectName: task?.projectName,
                    assignBy_id: task?.assignBy_id,
                    assignBy_Name: task?.assignBy_Name
                })),
            };

            const res = await axios.post(process.env.REACT_APP_BASE_URL + "/task/AddBulkTask", payload);
            toast.success("Planner Assigned Successfully");
            setShowViewModal(false);
            setSelectedPlanner(null);
            getAllPlanner();

        } catch (err) {
            console.log("assign error", err);
        }
    };

    return (
        <div className="AssignTask outletPadding" data-aos="fade-up">
            {
                showPlannerModal &&
                <CreatePlannerModal
                    show={showPlannerModal}
                    close={() => {
                        setShowPlannerModal(false);
                        setSelectedPlanner(null);
                        setIsEdit(false);
                    }}
                    editData={selectedPlanner}
                    isEdit={isEdit}
                    getAllPlanner={getAllPlanner}
                />
            }
            <ViewPlannerModal
                show={showViewModal}
                close={() => setShowViewModal(false)}
                item={selectedPlanner}
                getAllPlanner={getAllPlanner}
                handleAssignPlanner={handleAssignPlanner}
            />

            <AssignConfirmationModal
                show={showAssignConfirm}
                close={() => setShowAssignConfirm(false)}
                onConfirm={async () => {
                    await handleAssignPlanner(selectedPlanner);
                    setShowAssignConfirm(false);
                }}
            />

            {/* top button */}
            <div className="d-flex justify-content-end mb-4">

                <Button
                    className="activeBtn"
                    onClick={() => {
                        setSelectedPlanner(null);
                        setIsEdit(false);
                        setShowPlannerModal(true);
                    }}
                >
                    <Icon.PlusCircle className="me-2" />
                    Add Planner
                </Button>

            </div>

            {/* planner cards */}
            {
                loading ? (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: "60vh" }}
                    >
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">
                                Loading...
                            </span>
                        </div>
                    </div>
                ) : (
                    <Row className="mt-4">
                        {
                            plannerList?.map((item, index) => {
                                const firstTask = item?.taskList?.[0];
                                return (
                                    <Col lg={4} md={6} sm={12} key={index}>
                                        <Card
                                            className="border-0 shadow-sm mb-4"
                                            style={{
                                                borderRadius: "18px",
                                                overflow: "hidden",
                                                background: "#fff",
                                                transition: "0.3s ease",
                                            }}
                                        >
                                            <Card.Body>
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div>
                                                        <h5
                                                            className="fw-bold mb-2"
                                                            style={{
                                                                color: "#203759"
                                                            }}
                                                        >
                                                            {item?.plannerName}
                                                        </h5>

                                                        <p style={{ color: "#6c757d", fontSize: "14px", margin: "0px" }}>
                                                            {
                                                                firstTask?.taskTitle?.length > 20
                                                                    ? firstTask?.taskTitle
                                                                    : firstTask?.taskTitle
                                                            }
                                                        </p>
                                                        <p style={{ color: "#6c757d", fontSize: "14px", margin: "0px" }}
                                                        >
                                                            {
                                                                firstTask?.taskDescription?.length > 80
                                                                    ? firstTask?.taskDescription.substring(0, 80) + "..."
                                                                    : firstTask?.taskDescription
                                                            }
                                                        </p>

                                                    </div>

                                                    {/* icons */}
                                                    <div className="d-flex align-items-center">
                                                        <Icon.Eye
                                                            className="icon me-3"
                                                            size={18}
                                                            color="#203759"
                                                            title="View"
                                                            onClick={() => {
                                                                setSelectedPlanner(item);
                                                                setShowViewModal(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        />

                                                        <Icon.Pencil
                                                            className="icon me-3"
                                                            size={18}
                                                            color="#47AB64"
                                                            title="Edit"
                                                            onClick={() => {
                                                                setSelectedPlanner(item);
                                                                setIsEdit(true);
                                                                setShowPlannerModal(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        />

                                                        <Icon.PersonCheck
                                                            className="icon"
                                                            size={20}
                                                            color="#8E44AD"
                                                            title="Assigned Planner"
                                                            onClick={() => {
                                                                setSelectedPlanner(item);
                                                                setShowAssignConfirm(true);
                                                            }}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* bottom */}
                                                <div className="mt-4">
                                                    {/* start date */}
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="fw-semibold">
                                                            Start Date
                                                        </span>
                                                        <span>
                                                            {firstTask?.startDate}
                                                        </span>
                                                    </div>

                                                    {/* end date */}
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <span className="fw-semibold">
                                                            End Date
                                                        </span>
                                                        <span>
                                                            {firstTask?.endDate}
                                                        </span>
                                                    </div>

                                                    {/* estimate */}
                                                    {/* <div className="d-flex justify-content-between mb-2">
                                                        <span className="fw-semibold">
                                                            Estimate Time
                                                        </span>
                                                        <span>
                                                            {firstTask?.estimatedHours}h{" "}
                                                            {firstTask?.estimatedMinutes}m
                                                        </span>
                                                    </div> */}
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })
                        }

                    </Row>
                )
            }
        </div>


    );
};

export default Planner;